module.exports = __webpack_public_path__ + "img/icon_711.a31768dd.svg";